<template>
  <div class="py-2 my-2 help-container">
    <h1 class="separator py-4">REFORECAST</h1>
    <span class="banner py-3 mb-4">
      <div>You will be able to create a Reforecast of your budget to show more accurate numbers anticipated for year-to-date.</div>
      <div>It is <strong>not</strong> necessary to make any changes to your published, actual budget, unless desired.</div>
      <div>Most companies use the Reforecast to <strong>show owners/investors a closer approximation of their year-end numbers.</strong> These numbers would not affect your financial Budget Variance type reports. It would offer a separate set of numbers that would provide more information to your owners/investors.</div>
      <div>Expand the topic below for more information on that step.</div>
    </span>

    <!--Help Sections-->
    <v-expansion-panels v-model="openSectionInternal">
      <v-expansion-panel>
        <v-expansion-panel-header :color="getSectionColorFor(0)">
          <v-icon small class="icon" slot="actions" :color="getIconColorFor(0)">$vuetify.icons.expand</v-icon>
          <span class="header pl-3"><strong>Create a Reforecast</strong></span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="help-content">
          <div>The Reforecast ability will be available in the drop-down menu for Published versions only.</div>
          <img src="../../assets/help/rf1.png" />
          <div>When creating a Reforecast, you will have three options:</div>
          <ul>
            <li>I would like to create a Reforecast Budget that has current year actuals for all GL Accounts through _______.</li>
            <li class="no-bullet">
              <ul>
                <li>The Reforecast will provide Actual numbers for each month up to and including that month.</li>
              </ul>
            </li>
            <li>And, for the remaining months, I would like them populated with BUDGET NUMBERS / ZEROS</li>
            <li class="no-bullet">
              <ul>
                <li>All months after the month selected will be populated with which ever choice was selected.</li>
                <li>Note: The reason to choose zeros is to force the users to re-budget those months from scratch.</li>
              </ul>
            </li>
            <li>I would like to Deactivate the Market Rent and Occupancy worksheets and only enter my changes on GL Accounts: YES / NO</li>
            <li class="no-bullet">
              <ul>
                <li>If you select YES, all of the data on the Market Rent, Occupancy and any setting related to those tabs will be greyed out and not editable.</li>
                <li>If you select NO, the Market Rent and Occupancy tabs will work as normal.</li>
              </ul>
            </li>
          </ul>
          <div>All Flags, Comments, Calculations and Assumption statements will be copied over from the original budget to the Reforecasted budget.</div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header :color="getSectionColorFor(1)">
          <v-icon small class="icon" slot="actions" :color="getIconColorFor(1)">$vuetify.icons.expand</v-icon>
          <span class="header pl-3"><strong>Reporting Options</strong></span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="help-content">
          <ul>
            <li>While in the Reforecast budget, you can choose to export the Working Draft information.</li>
            <li class="no-bullet">
              <ul>
                <li>It will provide comparisons from your reforecast numbers to the default budget as well as your actual numbers.</li>
              </ul>
            </li>
            <li>On the core reporting menu, within the the Financial Comparison report is located within the Financial section of the reporting menu.</li>
            <li>It allows you to compare three sets of data side-by-side. These sets of data can be actual numbers or budget numbers for any period desired. If you select to use budget numbers within one of these sections, you will be able to select the specific budget within that Property, year and accounting period. If you have multiple version of a budget, you will be able to select which version to view.</li>
            <li>This will allow you to create a report that compares one version to another, in addition to comparing the data to actual numbers.</li>
          </ul>
          <img src="../../assets/help/rf2.png" />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel readonly>
        <v-expansion-panel-header>
          <v-icon slot="actions"></v-icon>
          <span class="black--text pointer">Prefer to watch a video? <a @click="openExternalTopic('BudgetsPro Reforecast')">Click Here</a></span>
        </v-expansion-panel-header>
      </v-expansion-panel>
      <v-expansion-panel readonly>
        <v-expansion-panel-header>
          <v-icon slot="actions"></v-icon>
          <span class="black--text pointer">Want to see all BudgetsPro help articles? <a @click="openExternalTopic('BudgetsPro')">Click Here</a></span>
        </v-expansion-panel-header>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import HelpMixin from '@/mixins/Help.js'
  export default {
    name: 'ReforecastHelp',
    mixins: [HelpMixin]
  }
</script>

<style lang="scss" scoped>
  .no-bullet {
    list-style-type: none;
  }
  .icon {
      order: 0;
  }
  .header {
      order: 1;
  }
  img {
    max-width: 650px;
  }
  img.small {
    width: 35px;
  }
  .help-container {
      border-bottom: 1px solid var(--v-resGrey-lighten1)
  }
  .help-content div,
  .help-content li {
      margin-top:10px !important;
      margin-bottom:10px !important;
  }
  .banner {
    text-align: center;
    background-color: var(--v-resGrey-lighten1);
    display: block;
  }
  .pointer {
      cursor: pointer !important;
  }
  .separator {
    display: flex;
    align-items: center;
    text-align: center;
  }
  .separator::before,
  .separator::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid var(--v-resGrey-darken1);
  }

  .separator:not(:empty)::before {
    margin-right: .25em;
  }

.separator:not(:empty)::after {
  margin-left: .25em;
}
</style>
